import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {NotFoundComponent} from './shared/components/not-found/not-found..component';
import {InvalidLinkComponent} from './invalid-link/invalid-link.component';
import {InstallerComponent} from "./installer/installer.component";
import {InstallBidComponent} from "./installer/install-bid/install-bid.component";
import {InstallBidsComponent} from "./installer/install-bids/install-bids.component";
import {InstallCompanyComponent} from './installer/install-company/install-company.component';

const routes: Routes = [
  {path: 'not-found', component: NotFoundComponent},
  {path: 'invalid', component: InvalidLinkComponent},
  {
    path: 'installer/:installerId',
    component: InstallerComponent,
    children: [
      { path: '', redirectTo: 'bids', pathMatch: 'full'},
      { path: 'bids',  component: InstallBidsComponent},
      { path: 'company',  component: InstallCompanyComponent},
      { path: 'bid/:installId', component: InstallBidComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
